import React, { useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import { useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import BookingInfo from "./BookingCosting_include/BookingInfo";
import ContainerInfo from "./BookingCosting_include/ContainerInfo";
import CustomerandSupplierinfo from "./BookingCosting_include/CustomerandSupplierinfo";
import Button from "react-bootstrap/Button";
import { Container } from "react-bootstrap";

axios.interceptors.request.use((config) => {
  config.headers["Access-Control-Allow-Origin"] = "*"; // Replace '*' with the desired domain or configure it dynamically
  config.headers["Access-Control-Allow-Methods"] = "GET, POST, PUT, DELETE";
  config.headers["Access-Control-Allow-Headers"] =
    "Content-Type, Authorization";
  return config;
});

const BookingCosting = () => {
  // const [baseUrl, setBaseUrl] = useState('http://127.0.0.1:8000/api/');
  const [baseUrl, setBaseUrl] = useState("http://mol.evolve-demo.com/api/");
  const [pageComponent, setPageComponent] = useState("bookingcosting");
  const [data, setData] = useState(undefined);
  const [selectedBookingItem, setSelectedBookingItem] = useState("");
  const [bookingNo, setBookingNo] = useState("");
  const [bLNumber, setBLNumber] = useState("");
  const [bookingDate, setBookingDate] = useState("");
  const [bLNO, setBLNO] = useState("");
  const [jobtypeCode, setJobtypeCode] = useState("");
  const [jobtypeDesc, setJobtypeDesc] = useState("");
  const [incotermCode, setIncotermCode] = useState("");
  const [incotermDesc, setIncotermDesc] = useState("");
  const [totalVol, setTotalVol] = useState("");
  const [polCode, setPolCode] = useState("");
  const [polDesc, setPolDesc] = useState("");
  const [podCode, setPodCode] = useState("");
  const [podDesc, setPodDesc] = useState("");
  const [etaEtdDate, setEtaEtdDate] = useState("");
  const [vessel, setVessel] = useState("");
  const [vesselDesc, setVesselDesc] = useState("");
  const [voyage, setVoyage] = useState("");
  const [voyageDesc, setVoyageDesc] = useState("");
  const [remark, setRemark] = useState("");
  const [carriercode, setCarriercode] = useState("");
  const [salesPerson, setSalesPerson] = useState("");
  const [salesPersonDesc, setSalesPersonDesc] = useState("");
  const [shipType, setShipType] = useState("");
  const [transTypeCode, setTransTypeCode] = useState("");
  const [transTypeDesc, setTransTypeDesc] = useState("");

  const [Con20FT, set_Con20FT] = useState("");
  const [Con40FT, set_Con40FT] = useState("");
  const [Con20RF, set_Con20RF] = useState("");
  const [Con40RF, set_Con40RF] = useState("");
  const [con_NumList, setCon_NumList] = useState([]);

  const [customer, setCustomer] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [rate, setRate] = useState("");
  const [rateCode, setRateCode] = useState("");
  const [exRate, setEXRate] = useState("");
  const [cost, setCost] = useState("");
  const [quoat, setQuoat] = useState("");
  const [supplier, setSupplier] = useState("");
  const [supplierName, setSupplierName] = useState("");
  const [rRate, setRRate] = useState("");
  const [cDate, setCDate] = useState("");
  const [volume, setVolume] = useState("");
  const [totalNBT, setTotalNBT] = useState("");
  const [totalVAT, setTotalVAT] = useState("");
  const [totalNBTQuote, setTotalNBTQuote] = useState("");
  const [totalVATQoute, setTotalVATQoute] = useState("");
  const [totalCost, setTotalCost] = useState("");
  const [totalQuote, setTotalQuote] = useState("");
  const [difference, setDifference] = useState("");
  const [CurrCode, setCurrCode] = useState("");
  const [CurrDesc, setCurrDesc] = useState("");
  const [vATPrecentage, setVATPrecentage] = useState("");
  const [nBTPrecentage, setNBTPrecentage] = useState("");

  const [tabledata, setTabledata] = useState([]);
  const [tableItem, setTableItem] = useState([]);

  const [selectedFiles, setSelectedFiles] = useState([]);

  const handleFunctionCall = async (value) => {
    if (value) {
      await axios
        .get(`http://mol.evolve-demo.com/api/bookingcosting/show/${value}`, {
          method: "GET",
          mode: "cors",
        })
        .then((response) => {
          // === get table values === //

          // === get table values End=== //

          // console.log(response.data.booking.booking_header_table_detail);
          setTabledata(response.data.booking.booking_header_table_detail);
          setTableItem(response.data.booking.booking_header_table_detail);
          // ===  CustomerSuplier === //
          setCost(response.data.booking.booking_detail[0][0].Cost);
          setSupplier(response.data.booking.booking_detail[0][0].SupplierCode);
          setSupplierName(
            response.data.booking.booking_detail[0][0].SupplierName
          );
          setCustomer(response.data.booking.booking_detail[0][0].CustCode);
          setCustomerName(response.data.booking.booking_detail[0][0].CustName);
          setRateCode(response.data.booking.booking_detail[0][0].RateCode);
          setRate(response.data.booking.booking_detail[0][0].Rate);
          setCurrCode(response.data.booking.booking_detail[0][0].CurrCode);
          setCurrDesc(response.data.booking.booking_detail[0][0].Currency);
          setQuoat(response.data.booking.booking_detail[0][0].Quoat);
          setRRate(response.data.booking.booking_detail[0][0].RateRemark);
          setCDate(response.data.booking.booking_detail[0][0].CreditDays);
          setVolume(response.data.booking.booking_detail[0][0].Volume);
          setTotalCost(response.data.booking.booking_detail[0][0].TotalCost);
          setEXRate(response.data.booking.booking_detail[0][0].ExRate);
          // selectCurruncy(response.data.booking.booking_detail[0][0].Currency);
          // ===  ContainerComponets === //
          set_Con20FT(response.data.booking.booking_detail[0][0]._20ft);
          set_Con40FT(response.data.booking.booking_detail[0][0]._40ft);
          set_Con20RF(response.data.booking.booking_detail[0][0]._20rf);
          set_Con40RF(response.data.booking.booking_detail[0][0]._40rf);
          setCon_NumList(
            response.data.booking.booking_detail[0][0].ContainerNO
          );

          setTransTypeCode(
            response.data.booking.booking_detail[0][0].TranModCode
          );
          setTransTypeDesc(
            response.data.booking.booking_detail[0][0].TranModDesc
          );
          const [dateBooking, timeBooking] =
            response.data.booking.booking_detail[0][0].BookingDate.split(" ");
          setBookingDate(dateBooking);
          setJobtypeCode(response.data.booking.booking_detail[0][0].JobCode);
          setJobtypeDesc(response.data.booking.booking_detail[0][0].JobDesc);
          setIncotermCode(response.data.booking.booking_detail[0][0].TermCode);
          setIncotermDesc(response.data.booking.booking_detail[0][0].TermDesc);
          setTotalVol(response.data.booking.booking_detail[0][0].TotalVolume);
          setPolCode(response.data.booking.booking_detail[0][0].POL);
          setPodCode(response.data.booking.booking_detail[0][0].POD);
          const [dateETAETD, timeETAETD] =
            response.data.booking.booking_detail[0][0].EtaEtd.split(" ");
          setEtaEtdDate(dateETAETD);
          setVessel(response.data.booking.booking_detail[0][0].VesCode);
          setVoyage(response.data.booking.booking_detail[0][0].VoyCode);
          setRemark(response.data.booking.booking_detail[0][0].Remark);
          setCarriercode(
            response.data.booking.booking_detail[0][0].CarrierCode
          );
          setBLNO(response.data.booking.booking_detail[0][0].BLNo);
          setSalesPerson(response.data.booking.booking_detail[0][0].SPCode);
          setSalesPersonDesc(response.data.booking.booking_detail[0][0].SPName);

          // selectCurruncy(response.data.booking[0].Currency);
        });
      console
        .log(tableItem)

        .catch((error) => {
          console.error(error);
        });
    }
  };

  const handleChangeCost = (Value) => {
    setCost(Value);
  };

  const handleSupplierName = (value) => {
    setSupplierName(value);
  };

  const handleNBTPrecentage = (value) => {
    setNBTPrecentage(value);
  };

  const handleVATPrecentage = (value) => {
    setVATPrecentage(value);
  };

  const handleCurrCode = (value) => {
    setCurrCode(value);
  };

  const handleCurrDesc = (value) => {
    setCurrDesc(value);
  };
  const handleDifference = (value) => {
    setDifference(value);
  };

  const handleTotalQuote = (value) => {
    setTotalQuote(value);
  };

  const handleTotalCost = (value) => {
    setTotalCost(value);
  };

  const handleTotalVATQoute = (value) => {
    setTotalVATQoute(value);
  };
  const handleCustomerName = (value) => {
    setCustomerName(value);
  };

  const handleTotalNBTQuote = (value) => {
    setTotalNBTQuote(value);
  };

  const handleTotalVAT = (value) => {
    setTotalVAT(value);
  };

  const handleTotalNBT = (value) => {
    setTotalNBT(value);
  };

  const handleVolume = (value) => {
    setVolume(value);
  };
  const handleCDate = (value) => {
    setCDate(value);
  };
  const handleRRate = (value) => {
    setRRate(value);
  };
  const handleSupplier = (value) => {
    setSupplier(value);
  };
  const handleQuoat = (value) => {
    setQuoat(value);
  };

  const handleExRate = (value) => {
    setEXRate(value);
  };

  const handleRate = (value) => {
    setRate(value);
  };

  const handleRateCode = (value) => {
    setRateCode(value);
  };

  const handlecustomer = (value) => {
    setCustomer(value);
  };

  const handleCon_NumList = (value) => {
    setCon_NumList(value);
  };

  const handle_Con40RF = (value) => {
    set_Con40RF(value);
  };

  const handle_Con20FT = (value) => {
    set_Con20FT(value);
  };
  const handle_Con40FT = (value) => {
    set_Con40FT(value);
  };
  const handle_Con20RF = (value) => {
    set_Con20RF(value);
  };

  const handleBookingNunber = (bookingNUM) => {
    setBookingNo(bookingNUM);
  };

  const hadleBLnumber = (BLNumber) => {
    setBLNumber(BLNumber);
  };

  const hadleBookingDate = (value) => {
    setBookingDate(value);
  };
  const hadleBLNO = (value) => {
    setBLNO(value);
  };
  const hadleJobtypeCode = (value) => {
    setJobtypeCode(value);
  };
  const hadleJobtypeCodeDesc = (value) => {
    setJobtypeDesc(value);
  };
  const hadleIncotermCode = (value) => {
    setIncotermCode(value);
  };
  const hadleIncotermDesc = (value) => {
    setIncotermDesc(value);
  };
  const hadleTotalVol = (value) => {
    setTotalVol(value);
  };
  const hadlePolCode = (value) => {
    setPolCode(value);
  };
  const hadlePolDesc = (value) => {
    setPolDesc(value);
  };
  const hadlePodCode = (value) => {
    setPodCode(value);
  };
  const hadlePodDesc = (value) => {
    setPodDesc(value);
  };
  const hadleEtaEtdDate = (value) => {
    setEtaEtdDate(value);
  };
  const hadleVessel = (value) => {
    setVessel(value);
  };
  const hadleVesselDesc = (value) => {
    setVesselDesc(value);
  };
  const hadleVoyage = (value) => {
    setVoyage(value);
  };
  const hadleVoyageDesc = (value) => {
    setVoyageDesc(value);
  };
  const hadleRemark = (value) => {
    setRemark(value);
  };
  const hadleCarriercode = (value) => {
    setCarriercode(value);
  };
  const hadleSalesPerson = (value) => {
    setSalesPerson(value);
  };
  const hadleSalesPersonDesc = (value) => {
    salesPersonDesc(value);
  };
  const hadleShipType = (value) => {
    setShipType(value);
  };
  const hadleTableData = (value) => {
    setTabledata(value);
  };
  const hadleTransTypeCode = (value) => {
    setTransTypeCode(value);
  };

  const hadleTransTypeDesc = (value) => {
    setTransTypeDesc(value);
  };

  useEffect(() => {
    fetch(`${baseUrl}${pageComponent}/customerindex`)
      .then((response) => response.json())
      .then((data) => {
        setData(data.bookingwiserates);
      });
  }, []);

  const bookingOnChange = (values) => {
    setSelectedBookingItem(values);
  };

  const handleChange = (name) => (e) => {};

  const saveBookingInfo = (res) => {
    console.log(selectedFiles);
    // const inputBookingData = {
    //   BookingDate: bookingDate,
    //   CarrierCode: carriercode,
    //   BLNo: bLNO,
    //   TranModCode: transTypeCode,
    //   JobCode: jobtypeCode,
    //   SPCode: salesPerson,
    //   TermCode: incotermCode,
    //   VesCode: vessel,
    //   VoyCode: voyage,
    //   TotalVolume: totalVol,
    //   POL: polCode,
    //   POD: podCode,
    //   EtaEtd: etaEtdDate,
    //   ShipmentType: shipType,
    //   TotalNBT: totalNBT ? totalNBT : 0,
    //   TotalVAT: totalVAT ? totalVAT : 0,
    //   TotalNBTQuote: totalNBTQuote ? totalNBTQuote : 0,
    //   TotalVATQoute: totalVATQoute ? totalVATQoute : 0,
    //   TotalCost: totalCost ? totalCost : 0,
    //   TotalQuote: totalQuote ? totalQuote : 0,
    //   Difference: difference ? difference : 0,
    //   UserId: "8",
    //   EntryDate: new Date(),
    //   CreditDays: cDate,
    //   Remark: remark,
    //   _20ft: Con20FT,
    //   _40ft: Con40FT,
    //   _20rf: Con20RF,
    //   _40rf: Con40RF,
    //   ContainerNO: con_NumList,
    //   CustName: customerName,
    //   CustCode: customer,
    //   SupplierName: supplierName,
    //   SupplierCode: supplier,
    //   RateRemark: rRate,
    //   Quoat: quoat,
    //   Cost: cost ? cost : 0,
    //   VATPrecentage: 15,
    //   NBTPrecentage: 0,
    //   Volume: volume,
    //   ExRate: exRate,
    //   CurrCode: CurrCode,
    //   BookingNo: bookingNo,
    //   Currency: CurrCode,
    //   File: selectedFiles,
    //   tabledata: tabledata,
    // };

    // console.log(inputBookingData);
    axios
      .post(
        `http://mol.evolve-demo.com/api/bookingcosting/store`,
        {
          BookingDate: bookingDate,
          CarrierCode: carriercode,
          BLNo: bLNO,
          TranModCode: transTypeCode,
          JobCode: jobtypeCode,
          SPCode: salesPerson,
          TermCode: incotermCode,
          VesCode: vessel,
          VoyCode: voyage,
          TotalVolume: totalVol,
          POL: polCode,
          POD: podCode,
          EtaEtd: etaEtdDate,
          ShipmentType: shipType,
          TotalNBT: totalNBT ? totalNBT : 0,
          TotalVAT: totalVAT ? totalVAT : 0,
          TotalNBTQuote: totalNBTQuote ? totalNBTQuote : 0,
          TotalVATQoute: totalVATQoute ? totalVATQoute : 0,
          TotalCost: totalCost ? totalCost : 0,
          TotalQuote: totalQuote ? totalQuote : 0,
          Difference: difference ? difference : 0,
          UserId: "8",
          EntryDate: "2023-07-12",
          CreditDays: cDate,
          Remark: remark,
          _20ft: Con20FT,
          _40ft: Con40FT,
          _20rf: Con20RF,
          _40rf: Con40RF,
          ContainerNO: con_NumList,
          CustName: customerName,
          CustCode: customer,
          SupplierName: supplierName,
          SupplierCode: supplier,
          RateRemark: rRate,
          Quoat: quoat,
          Cost: cost ? cost : 0,
          VATPrecentage: 15,
          NBTPrecentage: 0,
          Volume: volume,
          ExRate: exRate,
          CurrCode: CurrCode,
          RateCode: rateCode,
          BookingNo: bookingNo,
          Rate: rate,
          Currency: CurrCode,
          File: selectedFiles,
          tabledata: tabledata,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
      )
      .then((response) => {
        console.log(response);
        alert("Successfully Save Data");
      })
      .catch((error) => {
        console.error(error);
        alert(error);
      });
  };

  const handleFileChange = (event) => {
    const files = event.target.files;
    const convertedArray = [];

    console.log(event.target.files);

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const fileObject = {
        name: file.name,
        lastModified: file.lastModified,
        size: file.size,
        // Add other properties as needed...
      };
      convertedArray.push(fileObject);
    }

    console.log(convertedArray);

    setSelectedFiles(convertedArray);
    const selectedFilesArray = Array.from(files);
    // Filter only PDF files
    const pdfFiles = convertedArray.filter(
      (file) => file.type === "application/pdf"
    );

    if (pdfFiles.length === convertedArray.length) {
      setSelectedFiles(pdfFiles);
    } else {
      toast.error("Please select only PDF files.", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  const handleUpload = () => {
    console.log(selectedFiles);
  };

  return (
    <div className="">
      <ToastContainer autoClose={2000} />
      <Col>
        <h1>{bookingNo}</h1>
        <div className="p-3 w-100">
          <BookingInfo
            valueTotransTypeCode={transTypeCode}
            valueTotransTypeDesc={transTypeDesc}
            onhandletransTypeCode={hadleTransTypeCode}
            onhandletransTypeDesc={hadleTransTypeDesc}
            valueToBookingDate={bookingDate}
            handleChangeBookingDate={hadleBookingDate}
            valueTojobtypeCode={jobtypeCode}
            valueTojobtypeDesc={jobtypeDesc}
            onhandlejobtypeCode={hadleJobtypeCode}
            onhandlejobtypeDesc={hadleJobtypeCodeDesc}
            valueToIncotermCode={incotermCode}
            valueToIncotermDesc={incotermDesc}
            onhandleIncotermCode={hadleIncotermCode}
            onhandleIncotermDesc={hadleIncotermDesc}
            valueToTotalVolume={totalVol}
            handleChangeTotalVolume={hadleTotalVol}
            valueToPOLCode={polCode}
            valueToIPOLDesc={polDesc}
            onhandlePOLCode={hadlePolCode}
            onhandlePOLDesc={hadlePolDesc}
            valueToPoDCode={podCode}
            valueToPoDDesc={podDesc}
            onhandlePODCode={hadlePodCode}
            onhandlePODDesc={hadlePodDesc}
            valueToETAETD={etaEtdDate}
            handleChangeETAETD={hadleEtaEtdDate}
            valueTosessel={vessel}
            valueToVesselDesc={vesselDesc}
            onhandleVesselCode={hadleVessel}
            onhandleVesselDesc={hadleVesselDesc}
            valueToVoyage={voyage}
            valueToVoyageDesc={voyageDesc}
            onhandleVoyageCode={hadleVoyage}
            onhandleVoyageDesc={hadleVoyageDesc}
            valueToRemark={remark}
            handleChangeRemark={hadleRemark}
            valueToCarrierode={carriercode}
            handleChangeCarrierode={hadleCarriercode}
            valueToBLNO={bLNO}
            handleChangeBLNO={hadleBLNO}
            valueToSalesPerson={salesPerson}
            valueToSalesPersonDesc={salesPersonDesc}
            onhandleSalesPersonCode={hadleSalesPerson}
            onhandleSalesPersonDesc={hadleSalesPersonDesc}
            valueToShipType={shipType}
            handleChangeShipType={hadleShipType}
            callParentFunction={handleFunctionCall}
            handlevoy={voyage}
            handleChange={handleChange}
            pageComponent={pageComponent}
            baseUrl={baseUrl}
            selectedBookingItem={selectedBookingItem}
            bookingOnChange={bookingOnChange}
            onhandleBookingNunber={handleBookingNunber}
            onhadleBLnumber={hadleBLnumber}
            onhadleBookingDate={hadleBookingDate}
            onhadleTotalVol={hadleTotalVol}
            onhadleVessel={hadleVessel}
            onhadleVoyage={hadleVoyage}
            onhadleRemark={hadleRemark}
            onhadleCarriercode={hadleCarriercode}
            onhadleSalesPerson={hadleSalesPerson}
          />
          ,
          <ContainerInfo
            valueToCon20FT={Con20FT}
            handleChangeCon20FT={handle_Con20FT}
            valueToCon40FT={Con40FT}
            handleChangeCon40FT={handle_Con40FT}
            valueToCon20RF={Con20RF}
            handleChangeCon20RF={handle_Con20RF}
            valueToCon40RF={Con40RF}
            handleChangeCon40RF={handle_Con40RF}
            valueToConNUMList={con_NumList}
            handleChangeConNUMList={handleCon_NumList}
            valueToCost={cost}
            handleChange={handleChange}
            pageComponent={pageComponent}
            baseUrl={baseUrl}
            selectedBookingItem={selectedBookingItem}
            bookingNo={bookingNo}
            bLNumber={bLNumber}
            selectedBookingNO={bookingNo}
          />
          ,
          <CustomerandSupplierinfo
            valueToCost={cost}
            handleChangeCost={handleChangeCost}
            valueToExRate={exRate}
            onhandleExRate={handleExRate}
            valueToSupCode={supplier}
            valueToSupName={supplierName}
            onhandleSupplier={handleSupplier}
            onhandleSupplierName={handleSupplierName}
            valueToCustCode={customer}
            valueToCustName={customerName}
            onhandleCustCode={handlecustomer}
            onhandleCustomerName={handleCustomerName}
            valueToRate={rate}
            valueToRateCode={rateCode}
            onhandleRate={handleRate}
            onhandleRateCode={handleRateCode}
            valueToCurrCode={CurrCode}
            valueToCurrDesc={CurrDesc}
            onhandleCurrencyCode={handleCurrCode}
            onhandleCurrencyDesc={handleCurrDesc}
            valueToQuoat={quoat}
            onhandleQuoat={handleQuoat}
            valueToRateRemake={rRate}
            onhandleRRate={handleRRate}
            valueToCreditDays={cDate}
            onhandleCDate={handleCDate}
            valueToVolume={volume}
            onhandleVolume={handleVolume}
            valueTotalCost={totalCost}
            tabledata={tabledata}
            hadleTableDataset={hadleTableData}
            valueToTotalVAT={totalVAT}
            onhandleTotalVAT={handleTotalVAT}
            valueToTotalVATQoute={totalVATQoute}
            onhandleTotalVATQoute={handleTotalVATQoute}
            valueToTotalCost={totalCost}
            handleTotalCost={handleTotalCost}
            valueToTotalQuote={totalQuote}
            handleTotalQuote={handleTotalQuote}
            valueToTotalDifference={difference}
            handleTotalDifference={handleDifference}
            handleChange={handleChange}
            pageComponent={pageComponent}
            baseUrl={baseUrl}
            selectedBookingItem={selectedBookingItem}
            selectedBookingNO={bookingNo}
            bookingNo={bookingNo}
            bLNumber={bLNumber}
            onhandleTotalNBT={handleTotalNBT}
            onhandleTotalNBTQuote={handleTotalNBTQuote}
            onhandleVATPrecentage={handleVATPrecentage}
            onhandleNBTPrecentage={handleNBTPrecentage}
            saveBookingInfo={saveBookingInfo}
          />
          ,
          <div className="text-center">
            <Col className="text-end">
              <Button
                className="ms-3"
                variant="primary"
                onClick={saveBookingInfo}
              >
                Save
              </Button>

              <Button className="ms-3" variant="primary">
                New
              </Button>

              <Button className="ms-3" variant="primary">
                Update
              </Button>
              <Button className="ms-3" variant="primary">
                Delete
              </Button>
              <input
                className="ms-3 btn btn-primary"
                type="file"
                multiple
                onChange={handleFileChange}
              />
              {/* <Button
                    className="ms-3"
                    variant="primary"
                    onClick={handleUpload}
                  >
                    Attach Docs
                  </Button> */}

              <Button className="ms-3" variant="primary">
                Print
              </Button>

              <Button className="ms-3" variant="primary" type="submit">
                Cancel
              </Button>
            </Col>
          </div>
        </div>
      </Col>
    </div>
  );
};

export default BookingCosting;
